import { ContactForm } from "../interfaces/contact_form";

const WEB3FORMS_URL = "https://api.web3forms.com/submit";

// Sends a contact / free report form to info@triangular-pod.com via Web3Forms (replaces the old backend /contacts endpoint).
export const submitContactForm = async (form: ContactForm, subject: string) => {
  const response = await fetch(WEB3FORMS_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({
      access_key: process.env.WEB3FORMS_ACCESS_KEY,
      subject,
      from_name: "triangular-pod.com",
      replyto: form.email,
      botcheck: form.botcheck,
      name: `${form.firstName} ${form.lastName}`,
      email: form.email,
      phone: form.phoneNumber,
      contact_reason: form.contactReason,
      message: form.message,
      language: form.lang,
      agreed_to_terms_and_privacy: "yes"
    })
  });
  const result = await response.json();

  if (!response.ok || !result.success) {
    throw Error(result.message || response.statusText);
  }
};
